import React from 'react';
import { BookOpenIcon, CreditCardIcon, DownloadIcon, LockKeyholeIcon, ShieldCheckIcon, StarIcon, TrophyIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton, Section } from './Shared';
export function Pricing() {
  const reduceMotion = useReducedMotion();
  return <Section id="pricing" glow className="my-12 rounded-[2rem] border border-brand-gold/45 bg-brand-paper/65 shadow-[0_20px_55px_rgba(34,54,70,0.1)]" data-id="element-260" data-mp="2jkebmu1ud30d">
      <div className="mx-auto max-w-2xl text-center" data-id="element-261" data-mp="1rthxlq41osbi">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-forest px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-paper" data-id="element-262" data-mp="25s7up5qv6rzv">
          <StarIcon className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-263" data-mp="20rtlhkdj1c09" />
          Oferta de lanzamiento
        </span>
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-264" data-mp="3h97o64oy7cvh">
          TU <span className="text-brand-purple" data-id="element-265" data-mp="3caeaoc9nvlvb">BOTIQUÍN ANCESTRAL</span>
        </h2>
        <p className="mt-3 text-sm text-brand-muted md:text-base" data-id="element-266" data-mp="3vz71w0ckytr2">
          El precio de lanzamiento cierra pronto. Después sube $25.000 ARS.
        </p>
      </div>

      <div className="mx-auto mt-9 max-w-2xl" data-id="element-267" data-mp="9ta4zb61wish">
        <div className="rounded-3xl border-2 border-brand-gold/65 bg-brand-paper p-5 shadow-[0_14px_40px_rgba(128,96,31,0.14)] md:p-7" data-id="element-268" data-mp="9qe69kmdpq2z">
          <div className="flex items-center gap-2 text-brand-goldDark" data-id="element-269" data-mp="3d9h557p9bxwi">
            <TrophyIcon className="h-4 w-4" data-id="element-270" data-mp="3i81xym26jfax" />
            <StarIcon className="h-3.5 w-3.5 fill-current" data-id="element-271" data-mp="3i93hzg16bc4s" />
            <span className="text-[10px] font-bold uppercase tracking-[0.16em] md:text-xs" data-id="element-272" data-mp="3n7euxzmrm2r8">
              La caja de herramientas más completa
            </span>
          </div>
          <div className="mt-4 flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-273" data-mp="3rzy50mm8ufra">
            <div data-id="element-274" data-mp="2ugdabj0azf0b">
              <h3 className="font-serif text-xl font-bold text-brand-ink" data-id="element-275" data-mp="2zhkhpgyjac6g">
                EL BOTIQUÍN ANCESTRAL™
              </h3>
              <p className="mt-1 text-sm text-brand-muted" data-id="element-276" data-mp="2rg37sd7augs7">
                Ebook Principal + 6 Bonos · 60 páginas + material completo
              </p>
              <p className="mt-3 max-w-lg text-sm font-medium leading-relaxed text-brand-forest" data-id="element-277" data-mp="2mfxj95wbtaec">
                La caja de herramientas visual más completa de digitopuntura
                clínica para terapeutas y amantes de la medicina natural.
              </p>
            </div>
            <div className="shrink-0 text-left sm:text-right" data-id="element-278" data-mp="28i8w1resdr64">
              <p className="text-sm text-brand-muted line-through" data-id="element-279" data-mp="23jz4dqs9t8p9">
                $95.000 ARS
              </p>
              <p className="font-serif text-3xl font-bold text-brand-purple" data-id="element-280" data-mp="2igy9n7zngpgk">
                $27.990 ARS
              </p>
            </div>
          </div>
        </div>
        <motion.div animate={reduceMotion ? undefined : {
        y: [0, -2, 0]
      }} transition={{
        duration: 2.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mt-6" data-id="element-281" data-mp="3tutumxd8jsfp">
          <CTAButton fullWidth className="py-5 md:text-xl" data-id="element-282" data-mp="5b1k5zdjlgob">
            → QUIERO MI BOTIQUÍN ANCESTRAL $27.990
          </CTAButton>
        </motion.div>
        <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-5" aria-label="Beneficios de compra" data-id="element-283" data-mp="3rgf2nhtmrldm">
          <div className="flex min-h-[4.5rem] flex-col items-center justify-center rounded-xl border border-brand-green/20 bg-brand-paper px-2 py-2 text-center" data-id="element-284" data-mp="j26ecly55gr9">
            <BookOpenIcon className="h-4 w-4 text-brand-forest" aria-hidden="true" data-id="element-285" data-mp="a8ta4nummspv" />
            <span className="mt-1 text-[10px] font-semibold leading-tight text-brand-text" data-id="element-286" data-mp="e93i261zbt7d">
              Listo para imprimir o usar en tablet
            </span>
          </div>
          <div className="flex min-h-[4.5rem] flex-col items-center justify-center rounded-xl border border-brand-green/20 bg-brand-paper px-2 py-2 text-center" data-id="element-287" data-mp="16qzdera284q3">
            <LockKeyholeIcon className="h-4 w-4 text-brand-forest" aria-hidden="true" data-id="element-288" data-mp="3f5flyze76v7p" />
            <span className="mt-1 text-[10px] font-semibold leading-tight text-brand-text" data-id="element-289" data-mp="3592rw0eqqfcf">
              Pago seguro
            </span>
          </div>
          <div className="flex min-h-[4.5rem] flex-col items-center justify-center rounded-xl border border-brand-green/20 bg-brand-paper px-2 py-2 text-center" data-id="element-290" data-mp="319buveymf2zg">
            <CreditCardIcon className="h-4 w-4 text-brand-forest" aria-hidden="true" data-id="element-291" data-mp="3syncenqjlknt" />
            <span className="mt-1 text-[10px] font-semibold leading-tight text-brand-text" data-id="element-292" data-mp="3o6vsux5t0f76">
              Mercado Pago
            </span>
          </div>
          <div className="flex min-h-[4.5rem] flex-col items-center justify-center rounded-xl border border-brand-green/20 bg-brand-paper px-2 py-2 text-center" data-id="element-293" data-mp="kiva67wvdh2u">
            <DownloadIcon className="h-4 w-4 text-brand-forest" aria-hidden="true" data-id="element-294" data-mp="fr3tqq7fgrqf" />
            <span className="mt-1 text-[10px] font-semibold leading-tight text-brand-text" data-id="element-295" data-mp="23e86by3eis81">
              100% PDF
            </span>
          </div>
          <div className="col-span-2 flex min-h-[4.5rem] flex-col items-center justify-center rounded-xl border border-brand-green/20 bg-brand-paper px-2 py-2 text-center sm:col-span-1" data-id="element-296" data-mp="27f1u8rgug70x">
            <ZapIcon className="h-4 w-4 text-brand-forest" aria-hidden="true" data-id="element-297" data-mp="2hcy31cmb6pvv" />
            <span className="mt-1 text-[10px] font-semibold leading-tight text-brand-text" data-id="element-298" data-mp="2mckf3iqei033">
              Acceso inmediato
            </span>
          </div>
        </div>
        <p className="mt-4 text-center text-xs text-brand-muted" data-id="element-299" data-mp="2r66j6mii0vna">
          <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 text-brand-forest" data-id="element-300" data-mp="2v4w4r2doxji0" />
          Garantía de 7 días
        </p>
      </div>
    </Section>;
}